import { PharmacDateRangePicker, PharmacDateRangePickerProps, PharmacLabel } from '@pharmac/ui'
import {
  Control,
  Controller,
  FieldValues,
  Message,
  ValidationRule,
  useFormContext,
} from 'react-hook-form'

type ControllerRules = {
  required?: Message | ValidationRule<boolean>
}

type ControlledDateRangePickerProps = {
  control?: Control<FieldValues>
  label?: string
  rules?: ControllerRules
  startDateName: string
  endDateName: string
  width?: string
  calendarPlacement?: string
} & Required<
  Pick<
    PharmacDateRangePickerProps,
    'startDateText' | 'endDateText' | 'placeholder' | 'weekText' | 'calendarPlacement'
  >
>

export const ControlledDateRangePicker = (props: ControlledDateRangePickerProps) => {
  const isRequired = !!props.rules && !!props.rules.required
  const { watch, setValue } = useFormContext()

  const selectedDates = watch([props.startDateName, props.endDateName])

  const handleInput = (start: any, end: any) => {
    setValue(props.endDateName, end, { shouldDirty: true })
    setValue(props.startDateName, start, { shouldDirty: true })
  }

  return (
    <>
      {!!props.label && (
        <PharmacLabel marginSmallBottom>
          {props.label} {isRequired && '*'}
        </PharmacLabel>
      )}
      <Controller
        rules={props.rules}
        name=""
        control={props.control}
        render={() => (
          <PharmacDateRangePicker
            startDateText={props.startDateText}
            endDateText={props.endDateText}
            placeholder={props.placeholder}
            weekText={props.weekText}
            value={selectedDates}
            onChange={(start, end) => handleInput(start, end)}
            width={props.width}
            roundedBorders
            calendarPlacement={props.calendarPlacement}
          />
        )}
      />
    </>
  )
}
